
import { db } from "../model";

const getAllDrafts = async () =>{
    try {
        const drafts = await db.drafts.toArray();
        drafts.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        return drafts;
      } catch (err) {
        console.log("Error fetching the datapoints from the indexedDB!!!",err);
      }
}

const deleteDraftbyId = async(draftId) =>{
  const draft = await db.drafts.where("draftId").equals(draftId).first()
  console.log(draftId)
  try{
    await db.drafts.delete(draft.id)
  }catch{
    console.error("Failed to delete draft",draft.id)
  } 
  return draft.id
}

export {
    getAllDrafts,
    deleteDraftbyId
}